import {
  useQuery,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'

import { scenarioQueryKeys } from '../queryKeys'
import { jointScenarioQueryKeys } from '../../jointScenarios/queryKeys'
import { singularResourcefulScenarioRequest } from '../requests'

export function useRiskProfileQuery({
  scenarioID,
  initialData,
  queryKey,
  additionalInvalidationKeys
}) {
  const queryClient = useQueryClient()
  const riskProfileRequests = singularResourcefulScenarioRequest(
    scenarioID, 'risk_profile'
  )

  const riskProfileQuery = useQuery({
    queryFn: riskProfileRequests.show,
    queryKey,
    initialData
  })

  const updateRiskProfileMutation = useMutation({
    mutationFn: riskProfileRequests.update,
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).riskProfile] })
      await queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).forecasts] })
      queryClient.invalidateQueries({ queryKey: [scenarioQueryKeys(scenarioID).assets] })
      queryClient.invalidateQueries({ queryKey: [jointScenarioQueryKeys.forecast] })
      additionalInvalidationKeys.forEach(key => {
        queryClient.invalidateQueries({ queryKey: [key] })
      })
    },
  })

  const isFetching = riskProfileQuery.isFetching

  const isAnyLoading = riskProfileQuery.isFetching ||
    updateRiskProfileMutation.isLoading

  return {
    data: riskProfileQuery.data,
    actions: {
      update: updateRiskProfileMutation.mutateAsync,
    },
    status: riskProfileQuery.status,

    /* Boolean flags indicating various states of status */
    isFetching: isFetching,
    isAnyLoading: isAnyLoading
  }
}
